import { render, staticRenderFns } from "./menu-configuration.vue?vue&type=template&id=759eb424&"
import script from "./menu-configuration.vue?vue&type=script&lang=js&"
export * from "./menu-configuration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports